
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reseberattelser/[reseberattelse]",
      function () {
        return require("private-next-pages/reseberattelser/[reseberattelse].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reseberattelser/[reseberattelse]"])
      });
    }
  